import MarkdownPage from "../components/MarkdownPage";

export default function AcceptableUsePolicyPage() {
    return (
        <MarkdownPage
            title="Acceptable Use Policy – CV Box"
            description="Acceptable use policy for CV Box – prohibited activities and guidelines."
            markdownFile="/content/use-policy.md"
        />
    );
}